/* V78 · VIDEO-001 — HOMEPAGE GAME NIGHT VIDEO
 *
 * ŠALTINIO PERJUNGIMAS
 * Trys `<source media="...">` viename `<video>` NEVEIKIA — naršyklė
 * `media` atributą vertina tik `<picture>` viduje. Todėl variantą
 * parenka šis skriptas, ir parsisiunčiamas TIK VIENAS failas:
 *   >= 900 px  desktop 16:9
 *   600-899    tablet 1:1
 *   < 600 px   mobile 9:16
 *
 * `preload="none"` iki tol, kol nežinome, kurio reikia — todėl
 * pirmasis puslapio krovimas nesiunčia nė vieno megabaito video.
 *
 * VARTOTOJO VALIA GERBIAMA
 * Jei vartotojas pats sustabdė, grįžimas į viewport jo NEPALEIDŽIA
 * iš naujo. `userPaused` vėliavą nuima tik pats vartotojas.
 *
 * REDUCED-MOTION
 * Automatinio paleidimo NĖRA visai. Rodomas posteris ir paleidimo
 * mygtukas. Tai ne „sustabdyta animacija", o kitas srautas.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pick(v) {
    var w = window.innerWidth;
    var d = v.dataset;
    if (w >= 900) return { src: d.srcDesktop, poster: d.posterDesktop, kind: 'desktop' };
    if (w >= 600) return { src: d.srcTablet || d.srcDesktop, poster: d.posterTablet || d.posterDesktop, kind: 'tablet' };
    return { src: d.srcMobile || d.srcTablet || d.srcDesktop, poster: d.posterMobile || d.posterDesktop, kind: 'mobile' };
  }

  function Player(root) {
    if (root.dataset.gnvReady === '1') return;
    root.dataset.gnvReady = '1';

    var video = root.querySelector('[data-gn-video]');
    var playBtn = root.querySelector('[data-gn-play]');
    var playIcon = root.querySelector('[data-gn-play-icon]');
    var soundBtn = root.querySelector('[data-gn-sound]');
    var soundIcon = root.querySelector('[data-gn-sound-icon]');
    var frame = root.querySelector('[data-gn-frame]');
    if (!video) return;

    var wantAuto = root.dataset.gnAutoplay === '1' && !REDUCED;
    var userPaused = false;
    var current = '';

    video.loop = root.dataset.gnLoop === '1';
    video.muted = true;
    video.playsInline = true;

    function applySource() {
      var s = pick(video);
      if (s.poster) video.poster = s.poster;
      if (!s.src) return false;                 // video dar neįkeltas
      if (s.src === current) return true;       // to paties nesiunčiam antrą kartą
      current = s.src;
      var wasPlaying = !video.paused;
      video.src = s.src;
      video.load();
      if (wasPlaying && !userPaused) safePlay();
      return true;
    }

    function safePlay() {
      var p = video.play();
      /* Naršyklė gali atmesti autoplay. Tai ne klaida — tiesiog
         paliekame posterį ir paleidimo mygtuką. */
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function syncIcons() {
      var playing = !video.paused && !video.ended;
      if (playIcon) playIcon.innerHTML = playing ? '&#10074;&#10074;' : '&#9654;';
      if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pristabdyti' : 'Paleisti');
      if (soundIcon) soundIcon.innerHTML = video.muted ? '&#128263;' : '&#128266;';
      if (soundBtn) {
        soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        soundBtn.setAttribute('aria-label', video.muted ? 'Įjungti garsą' : 'Išjungti garsą');
      }
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) { userPaused = false; if (applySource()) safePlay(); }
        else { userPaused = true; video.pause(); }
        syncIcons();
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        /* Įjungus garsą vartotojas akivaizdžiai nori žiūrėti. */
        if (!video.muted && video.paused) { userPaused = false; if (applySource()) safePlay(); }
        syncIcons();
      });
    }

    video.addEventListener('play', syncIcons);
    video.addEventListener('pause', syncIcons);

    /* Už ekrano ribų — stabdome. Grįžus tęsiame TIK jei vartotojas
       pats nebuvo sustabdęs. */
    var io = null;
    if ('IntersectionObserver' in window && frame) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (wantAuto && !userPaused) { if (applySource()) safePlay(); }
            else applySource();
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      io.observe(frame);
      root._gnvIO = io;
    } else {
      applySource();
      if (wantAuto && !userPaused) safePlay();
    }

    /* Breakpoint pasikeitus perjungiame šaltinį. */
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var opts = ac ? { signal: ac.signal } : false;
    root._gnvAbort = ac;
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(applySource, 250);
    }, opts);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !video.paused) video.pause();
    }, opts);

    applySource();
    syncIcons();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gnvideo]').forEach(Player);
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-gnvideo]') : null;
    if (r && r._gnvAbort) { try { r._gnvAbort.abort(); } catch (err) {} }
    if (r && r._gnvIO) { try { r._gnvIO.disconnect(); } catch (err) {} }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
